import Element from '../element';
import store from '@/store';
import { stringUtil } from '../stringUtil';
import { SlotItem } from '../slotItem';
import { Vector2 } from '@babylonjs/core';
import { BaseCommand } from './baseCommand';
import { AddWallsCommand } from './addWallsCommand';
import { AddHandlesToFrontCommand } from './addHandlesToFrontCommand';

export class AddFrontsToDrawerCommand extends BaseCommand {

    constructor(
        private drawer: Element,
        scenePreview: any,
        private onFinish: () => void = () => { },
    ) {
        super(scenePreview);
    }

    public execute(): void {
        const position = this.drawer.position.clone();
        const shape = new Vector2(this.drawer.shape.x, 1);
        const slot = new SlotItem('', position, shape);
        const model = stringUtil.createFrontModel(this.drawer, shape, slot);
        const light = stringUtil.createFrontLight(this.drawer, shape, slot);
        const shader = store.getters.shaders.selectedFront;
        this.scenePreview.addElement(model, light, shader, position, shape, (x: Element) => {
            x.menuElement = this.drawer.menuElement;
            x.slot = this.drawer.slot;
            this.drawer.bind(x);
            this.elements.push(x);
            const addWallsCommand = new AddWallsCommand(x, this.scenePreview, this.onFinish);
            this.addCommand(addWallsCommand);
            const addHandlesCommand = new AddHandlesToFrontCommand(x, this.scenePreview);
            this.addCommand(addHandlesCommand);
        });
    }
}
